import aboutUs from "../../assets/images/navy_center.jpg";
import './About.css';
import { NavLink } from 'react-router-dom';

function About() {
    const values = [
        {
            icon: "🎯",
            title: "Strategic Focus",
            description: "We develop targeted strategies that align with your business objectives and market opportunities."
        },
        {
            icon: "🚀",
            title: "Innovation",
            description: "We embrace cutting-edge technologies and creative approaches to deliver exceptional results."
        },
        {
            icon: "🤝",
            title: "Partnership",
            description: "We build lasting relationships based on trust, transparency, and mutual success."
        },
        {
            icon: "📈",
            title: "Results-Driven",
            description: "We measure success by the tangible impact we create for your business growth."
        }
    ];

    return(
        <div className="about-page">
            {/* Hero Section */}
            <section className="about-hero">
                <div className="about-hero-image">
                    <img src={aboutUs} alt="SCPO Group Team" />
                    <div className="about-hero-overlay">
                        <div className="about-hero-content">
                            <h1>Your Vision, Our Strategy</h1>
                            <p>Building lasting partnerships through innovative business solutions</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* About Content Section */}
            <div className="about-content">
                <div className="about-container">
                    <div className="about-header">
                        <h2>About SCPO Group Inc</h2>
                        <p>We are a dynamic business consulting and marketing agency dedicated to helping companies achieve their goals through strategic innovation and creative excellence.</p>
                    </div>

                    <div className="about-mission-approach-container">
                        <div className="about-mission-block">
                            <h3>Our Mission</h3>
                            <p>
                                At SCPO, we believe in building long-lasting partnerships with our clients. Whether you're a
                                startup aiming to establish your presence or a well-known brand looking to expand, our team is
                                ready to guide you with innovative strategies tailored to your business goals. We are committed
                                to delivering solutions that combine creativity, data-driven insights, and industry expertise.
                            </p>
                        </div>
                        <div className="about-approach-block">
                            <h3>Our Approach</h3>
                            <p>
                                Our consulting services are designed to help you identify opportunities, overcome challenges,
                                and improve overall performance. From market research and competitor analysis to strategic planning,
                                we provide the tools and insights necessary to take your business forward. We specialize in creating
                                integrated marketing campaigns that speak directly to your audience.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Values Section */}
            <div className="about-values-section">
                <div className="about-container">
                    <div className="about-values-header">
                        <h2>Our Core Values</h2>
                        <p>The principles that guide everything we do</p>
                    </div>
                    <div className="about-values-grid">
                        {values.map((value, index) => (
                            <div key={index} className="about-value-card">
                                <div className="about-value-icon">{value.icon}</div>
                                <h3>{value.title}</h3>
                                <p>{value.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Contact CTA Section */}
            <div className="about-contact-cta">
                <div className="about-container">
                    <div className="about-cta-content">
                        <h2>Ready to Work With Us?</h2>
                        <p>Let's discuss how we can help your business grow and succeed</p>
                        <div className="about-cta-buttons">
                            <NavLink to="/contact" className="about-btn about-btn-primary" onClick={() => window.scrollTo(0, 0)}>Get In Touch</NavLink>
                            <NavLink to="/services" className="about-btn about-btn-secondary" onClick={() => window.scrollTo(0, 0)}>Our Services</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
